import type { RGBA } from "models-webgl2";
import { isFiniteZeroPositive } from "utils/math/is-finite-zero-positive";
import { normalize } from "utils/math/normalize";

export const hexToRgba = (hex: string, normalized = false): RGBA => {
  if (hex.replace("#", "").length === 3) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (_, r, g, b) => {
      return r + r + g + g + b + b;
    });
  }

  const res = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
  if (!res) return [0, 0, 0, 0];

  const r = parseInt(res[1], 16);
  const g = parseInt(res[2], 16);
  const b = parseInt(res[3], 16);
  let a = parseInt(res[4], 16);
  a = isFiniteZeroPositive(a) ? a : 255;

  return [
    getNormalizedColor(r, normalized),
    getNormalizedColor(g, normalized),
    getNormalizedColor(b, normalized),
    getNormalizedColor(a, normalized),
  ];
};

const getNormalizedColor = (color: number, normalized?: boolean) => {
  return normalized ? normalize(color, 0, 255) : color;
};
